import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {FloatLayout} from '../../../components/float-layout';
import {BoxDimensions} from '../../../components/layout/abstract-units';
import {LayoutChanges} from '../../../components/layout/layout-changes';
import {FloatLayoutService} from './float-layout.service';

/**
 * The MockOf type takes a class and an optional union of
 * public members which we don't want to have to implement in
 * our mock.
 * @example
 * class MockMyClass implements MockOf<MyClass, 'unimportantField' | 'unimportantMethod'> {
 *     importantMethod(input: string): string {
 *         return 'a test string';
 *     }
 * }
 */
type MockOf<Class, Omit extends keyof Class = never> = {
    [Member in Exclude<keyof Class, Omit>]: Class[Member];
};

@Injectable()
export class FakeFloatLayoutService implements MockOf<FloatLayoutService> {

    public floatLayout: FloatLayout;
    public layoutResize$: Observable<any>;
    public placementBoardDimensions: BoxDimensions;

    public setFloatLayout(): void {
        // Support for empty method
    }

    public createFloatCellByDefinition(): void {
        // Do nothing.
    }

    public hideAllCellComponents(): void {
        // Do nothing.
    }

    public showAllCellComponents(): void {
        // Do nothing.
    }

    public applyPlacement(): LayoutChanges {

        // Do nothing.
        return null;
    }

}
